import React, { useState, useEffect } from 'react';
import { Card, Button, Input, PageHeader, Alert } from '../../components/ui';
import api from '../../services/api';
import toast from 'react-hot-toast';

export default function PlanPricing() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState('');
  const [forms, setForms] = useState({});

  useEffect(() => { fetchPlans(); }, []);

  const fetchPlans = async () => {
    try {
      const r = await api.get('/superadmin/plans');
      setPlans(r.data.plans || []);
      const f = {};
      (r.data.plans || []).forEach(p => { f[p.planId] = { price: p.price, emailsPerMonth: p.emailsPerMonth, verifyPerMonth: p.verifyPerMonth, accountsLimit: p.accountsLimit, warmupLimit: p.warmupLimit }; });
      setForms(f);
    } catch { toast.error('Failed to load plans'); } finally { setLoading(false); }
  };

  const savePlan = async (planId) => {
    setSaving(planId);
    try {
      await api.put(`/superadmin/plans/${planId}`, forms[planId]);
      toast.success(`${planId.replace(/_/g,' ')} updated!`);
      fetchPlans();
    } catch (e) { toast.error(e.response?.data?.message || 'Failed'); } finally { setSaving(''); }
  };

  const updateForm = (planId, key, value) => setForms(p => ({ ...p, [planId]: { ...p[planId], [key]: value } }));

  const PLAN_COLORS = { pack_one: '#2ECC71', pack_two: '#3498DB', pack_advanced: '#F39C12' };

  return (
    <div>
      <PageHeader title="Plan Pricing" subtitle="Edit plan prices, credits and limits" />
      <Alert type="info" style={{ marginBottom: 24 }}>Changes apply to new subscriptions only. Existing active clients keep their current plan until renewal.</Alert>

      {loading ? <div style={{ color:'#555', textAlign:'center', padding:40 }}>Loading...</div> : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px,1fr))', gap: 20 }}>
          {plans.map(plan => (
            <Card key={plan.planId} style={{ border: `1px solid ${PLAN_COLORS[plan.planId]}33` }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, paddingBottom: 16, borderBottom: `1px solid ${PLAN_COLORS[plan.planId]}22` }}>
                <div>
                  <div style={{ fontSize: 11, fontWeight: 800, color: PLAN_COLORS[plan.planId], textTransform: 'uppercase', letterSpacing: 1.5, marginBottom: 4 }}>{plan.planId?.replace(/_/g,' ')}</div>
                  <div style={{ fontSize: 28, fontWeight: 900, color: '#fff' }}>€{forms[plan.planId]?.price}<span style={{ fontSize: 13, color: '#555', fontWeight: 400 }}>/mo</span></div>
                </div>
                <div style={{ width: 44, height: 44, borderRadius: 12, background: `${PLAN_COLORS[plan.planId]}18`, border: `1px solid ${PLAN_COLORS[plan.planId]}33`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20 }}>
                  {plan.planId === 'pack_one' ? '🌱' : plan.planId === 'pack_two' ? '🚀' : '🏢'}
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {[
                  ['Price (€/month)', 'price', 'number', ''],
                  ['Contacts limit (-1 = unlimited)', 'contactsLimit', 'number', ''],
                  ['Email Sends / month (-1 = unlimited)', 'emailSendsLimit', 'number', ''],
                  ['Verifications / month (-1 = unlimited)', 'verifyLimit', 'number', ''],
                  ['Accounts limit (-1 = unlimited)', 'accountsLimit', 'number', ''],
                  ['Warmup limit (-1 = unlimited)', 'warmupLimit', 'number', ''],
                ].map(([label, key, type]) => (
                  <div key={key} style={{ marginBottom: 10 }}>
                    <label style={{ display: 'block', fontSize: 12, color: '#666', marginBottom: 5, fontWeight: 600 }}>{label}</label>
                    <input type={type} value={forms[plan.planId]?.[key] ?? ''} onChange={e => updateForm(plan.planId, key, parseFloat(e.target.value) || 0)}
                      style={{ width: '100%', padding: '9px 12px', background: '#1a1a1a', border: `1px solid ${PLAN_COLORS[plan.planId]}25`, borderRadius: 9, color: '#fff', fontSize: 14, fontWeight: 600, outline: 'none' }} />
                  </div>
                ))}
              </div>

              <Button fullWidth loading={saving === plan.planId} onClick={() => savePlan(plan.planId)} style={{ marginTop: 8, background: PLAN_COLORS[plan.planId], color: plan.planId === 'pack_one' ? '#000' : '#000' }}>
                💾 Save Changes
              </Button>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
